<div class="grid grid-cols-[168px_1fr] items-center gap-3">
  <div>
    <p class="text-text text-xs font-medium">
      {{ risk().label }}
    </p>
  </div>

  <!-- Div for Bar and Badge -->
  <div class="risk-bar-container relative w-full">
    @if (risk().type !== 'loading') {
      <div
        class="absolute -top-[10px] z-10"
        [style.margin-inline-start]="primaryMarginStart"
      >
        <dxc-badge
          additionalClasses="w-6 h-6 min-w-6 !p-0"
          [style]="riskDetail.badgeStyle || 'white'"
          [text]="risk().score || ''"
          [tooltip]="tooltip"
        />
      </div>
      @if (secondaryRiskDetail) {
        <div
          class="absolute -top-[10px] z-10"
          [style.margin-inline-start]="secondaryMarginStart"
        >
          <dxc-badge
            additionalClasses="w-6 h-6 min-w-6 !p-0"
            [style]="secondaryRiskDetail.badgeStyle || 'white'"
            [text]="risk().dxcCalcScore || ''"
            [tooltip]="'DXC Calc Score'"
          />
        </div>
      }
    }
    <div
      class="bg-border flex h-2 w-full overflow-hidden rounded-full"
      role="progressbar"
      aria-valuemax="5"
      aria-valuemin="0"
      [attr.aria-valuenow]="risk().score"
    >
      <div
        class="flex flex-col justify-center overflow-hidden whitespace-nowrap rounded-l-full {{
          riskDetail.barColour
        }}"
        [style.width]="primaryBarWidth"
      ></div>
      @if (secondaryRiskDetail) {
        <div
          class="flex flex-col justify-center overflow-hidden whitespace-nowrap {{
            secondaryRiskDetail.barColour + ' opacity-25'
          }}"
          [style.width]="secondaryBarWidth"
        ></div>
      }
    </div>
  </div>
</div>
